var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysInvoicePending = function SvgSysInvoicePending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sysInvoicePending_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.02,
    d: "M4.5 6.5h1M4.5 9.5h3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m5.891 2.576-1.445.965a.177.177 0 0 1-.207-.016l-1-.949a.535.535 0 0 0-.282-.076.424.424 0 0 0-.457.373v10.254a.424.424 0 0 0 .457.373.535.535 0 0 0 .278-.076l1-.949a.177.177 0 0 1 .207-.016l1.445.965a.542.542 0 0 0 .55 0l1.463-.976a.18.18 0 0 1 .192 0l1.463.977a.544.544 0 0 0 .551 0l1.445-.965a.177.177 0 0 1 .207.016l1 .949a.536.536 0 0 0 .643-.076c.057-.06.09-.14.091-.222V10.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FD9001",
    d: "M10.75 9.5a4.25 4.25 0 1 0 0-8.5 4.25 4.25 0 0 0 0 8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.75 2.75a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2a.5.5 0 0 1 .5-.5ZM10.75 6.75a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sysInvoicePending_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgSysInvoicePending;